import { render, staticRenderFns } from "./RoApcnPopupTableInfo6.vue?vue&type=template&id=454b37ae&"
import script from "./RoApcnPopupTableInfo6.vue?vue&type=script&lang=js&"
export * from "./RoApcnPopupTableInfo6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports